import { DisplayOnBreakpoints } from "@dotcom/ui";
import styled from "@emotion/styled";
import {
  Section,
  Grid,
  GridColumn,
  Heading,
  Paragraph,
} from "@polestar/component-warehouse-react";

interface Props {
  readonly title: string;
  readonly body: string;
}

const StyledHeadingBody = styled(Heading)`
  white-space: pre-line;
`;

const StyledParagraphBody = styled(Paragraph)`
  white-space: pre-line;
`;

const Hero = ({ title, body }: Props) => {
  return (
    <Section>
      <Grid>
        <GridColumn span={{ mobile: 4, tablet: 4, desktop: 3 }}>
          <Heading level={1}>{title}</Heading>
        </GridColumn>

        <GridColumn
          span={{ mobile: 4, tablet: 8, desktop: 7 }}
          offset={{ desktop: 1 }}
        >
          {/* Paragraph on mobile */}
          <DisplayOnBreakpoints display={{ mobile: "block", tablet: "none" }}>
            <StyledParagraphBody>{body}</StyledParagraphBody>
          </DisplayOnBreakpoints>

          {/* Heading on tablet and desktop */}
          <DisplayOnBreakpoints display={{ mobile: "none", tablet: "block" }}>
            <StyledHeadingBody as="p">{body}</StyledHeadingBody>
          </DisplayOnBreakpoints>
        </GridColumn>
      </Grid>
    </Section>
  );
};

export default Hero;
